import React from "react";
import logo from '../assets/images/oro-back-logo.png';

export default function ObPortfolioBaseCard(props) {
  return (
    <div
    // style={props.isTotal ? {backgroundImage: `url(${logo})`} : {}}
      className={
        "base-card d-flex flex-column align-items-start justify-content-center " +
        (props.isTotal ? "card-total" : "")
      }
    >
      <p className="pf-header">{props.title}</p>
      <p className="font-weight-semi-bold pf-value">{props.value}</p>
    </div>
  );
}
